import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import { createTmpUploadedFiles } from '../../../handler/ChatAIHandler';
import {
    validateUploadFiles,
    createTmpFileObjects,
    VALID_FILE_ACCEPT
} from '../handler/UploadFileHandler';
import FileIcon from '@/component/common/icons/FileIcon';

const UploadFile = forwardRef(function UploadFile({
    corporationDetail,
    projectInuseDetail,
    chatThreadId,
    uploadFiles,
    uploadImgs = [],
    setUploadFiles,
    setIsUploading,
    showButton = true
}, ref) {
    const fileInputRef = useRef(null);
    const { enqueueSnackbar } = useSnackbar();

    useImperativeHandle(ref, () => ({
        triggerClick: () => {
            fileInputRef.current?.click();
        }
    }));

    const handleSelectFiles = (event) => {
        const selectedFiles = Array.from(event.target.files);
        if (!selectedFiles || selectedFiles.length === 0) {
            event.target.value = '';
            return;
        }

        const isValidFiles = validateUploadFiles(selectedFiles, uploadFiles, uploadImgs, enqueueSnackbar);
        if (!isValidFiles) {
            event.target.value = '';
            return;
        }

        const files = createTmpFileObjects(selectedFiles);
        setUploadFiles(prev => [...prev, ...files]);

        createTmpUploadedFiles(
            corporationDetail.id,
            projectInuseDetail.id,
            chatThreadId,
            files,
            setUploadFiles,
            setIsUploading
        );

        event.target.value = ''; // reset after selected
    };

    return (
        <div>
            {showButton && (
                <button
                    className="btn-reset-default ai-chat-input-btn"
                    onClick={() => fileInputRef.current?.click()}
                >
                    <FileIcon width={20} height={16} />
                </button>
            )}
            <input
                style={{ display: 'none' }}
                ref={fileInputRef}
                type="file"
                multiple
                accept={VALID_FILE_ACCEPT}
                onChange={handleSelectFiles}
            />
        </div>
    );
});

UploadFile.propTypes = {
    corporationDetail: PropTypes.object,
    projectInuseDetail: PropTypes.object,
    chatThreadId: PropTypes.string,
    uploadFiles: PropTypes.array,
    uploadImgs: PropTypes.array,
    setUploadFiles: PropTypes.func,
    setIsUploading: PropTypes.func,
    enqueueSnackbar: PropTypes.func,
    showButton: PropTypes.bool
};

export default UploadFile;
